import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep.js';
import HTMLContainer from './HTMLContainer.js';

const Strong = (props) => {
	return (
		<strong {...props}>{props.children}</strong>
	);
};

const Header2 = (props) => {
	return (
		<h2 {...props}>{props.children}</h2>
	);
};

export const SuccessMessage = injectIntl((props) => {
	return (
		<Message
			icon='knk-on'
			{...props}
			type='success'
		/>
	)
});

export const AlertMessage = injectIntl((props) => {
	return (
		<Message
			icon='knk-alert'
			{...props}
			type='alert'
		/>
	)
});

export const UsetifulMessage = injectIntl((props) => {
	return (
		<Message
			icon='knk-tip'
			{...props}
			type='tip'
		/>
	)
});

export const InformationMessage = injectIntl((props) => {
	return (
		<Message
			icon='knk-information'
			{...props}
			type='information'
		/>
	)
});

const Message = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const classname = props?.classname ?? 'gui_message';
	let classes = classname.split(" ");

	const custom_title_content = props?.custom_title_content ?? false;
	let message_title = (isNotEmpty(props, 'title')) ? props.title : false;
	if((props?.center_title ?? false) == false) {
		classes.push('gui_text_align_start');
	} else {
		classes.push('gui_text_align_center');
	}
	if(message_title === false || message_title == "") classes.push('without_title');
	if(props.children == undefined) classes.push('only_title');

	const autotranslate = props?.autotranslate ?? true;
	if(message_title) message_title = (autotranslate) ? i18n(message_title) : message_title;

	let is_custom = null;

	let icon = props?.icon ?? 'default';

	const type = props?.type ?? 'information';

	switch(type) {
		case 'alert':
		case 'error':
			classes.push('alert_warning');
			break;

		case 'black':
		case 'blank':
			classes.push('blank_message');
			break;

		case 'addon':
		case 'blue':
		case 'success':
			classes.push(`${type}_message`);
			break;

		case 'custom':
			is_custom = props?.color ?? '#000000';
			classes.push('custom_bg_message');
			break;

		case 'tip':
			classes.push('tip_message');
			break;

		case 'information':
		default:
			classes.push('information_message');
			if(icon == 'default') icon = 'knk-tip';
			break;
	}

	let title_icon = null;
	let message_icon = null;
	if(icon !== false) {
		title_icon = icon;
		message_icon = icon;
	} else {
		classes.push('without_icon');
	}

	if(props._class != undefined) {
		for(var i in props._class) {
			switch(i) {
				case 'arrow':
					classes.push(`with_${props._class[i]}_arrow`);
					break;

				default:
					classes.push(props._class[i]);
					break;
			}
		}
	}

	const isString = (typeof props.children == 'string') ? true : false;

	const TitleComponent = (props.title_component != undefined && props.title_component == 'strong') ? Strong : Header2;

	let title_styles = props?.title_styles ?? null;
	let message_styles = props?.custom_styles ?? null;
	if(is_custom != undefined) {
		if(title_styles != undefined) {
			title_styles.backgroundColor = is_custom;
			title_styles.borderColor = is_custom;
		} else {
			title_styles = { backgroundColor:is_custom, borderColor:is_custom };
		}

		if(message_styles != undefined) {
			message_styles.borderColor = is_custom;
		} else {
			message_styles = { borderColor:is_custom };
		}
	}

	let extra_classes = ['msg_contents'];
	if(props.extra_msg_classes != undefined) extra_classes.push(props.extra_msg_classes);
	if(!message_title && message_icon) extra_classes.push(message_icon);

	return (
		<HTMLContainer
			id={props.id}
			type={props?.wrapper_type ?? 'div'}
			className={classes.join(" ")}
			style={message_styles}
		>
			{(message_title && !custom_title_content) && (
				<TitleComponent
					class={title_icon}
					style={title_styles}
					dangerouslySetInnerHTML={{ __html:message_title }}
				/>
			)}

			{(message_title && custom_title_content) && (
				<TitleComponent
					class={title_icon}
					style={title_styles}
				>{message_title}</TitleComponent>
			)}

			{(props.children != undefined) && (
				(isString) ? (
					<div class={extra_classes.join(" ")} dangerouslySetInnerHTML={{ __html:props.children.replace(/\n/g, '<br />') }} />
				) : (
					<div class={extra_classes.join(" ")}>
						{props.children}
					</div>
				)
			)}
		</HTMLContainer>
	)
};

export default injectIntl(Message);